export default function getSubscriptionPlans(plans) {
  if (plans) {
    return plans.filter((plan) => plan.active && plan.trialPeriod === 0);
  } else {
    return null;
  }
}
